import { Chip, Tooltip } from "@mui/material";

import HelpIcon from "@mui/icons-material/Help";

import CopyToClipboardIcon from "./buttons/CopyToClipboardIcon";

import { truncateText } from "@aclymatepackages/other-helpers";

const IdDisplayChip = ({ id, type = "object" }) => {
  return (
    <Chip
      icon={
        <Tooltip
          title={`This is this ${type}'s database ID. It might be requested by the Aclymate Team to help resolve support issues.`}
        >
          <HelpIcon />
        </Tooltip>
      }
      label={`ID: ${truncateText(id, 10)}`}
      deleteIcon={<CopyToClipboardIcon text={id} />}
      onDelete={() => {}}
    />
  );
};

export default IdDisplayChip;
